import { render, staticRenderFns } from "./SetpointsView.vue?vue&type=template&id=445c0320&scoped=true"
import script from "./SetpointsView.vue?vue&type=script&lang=ts"
export * from "./SetpointsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445c0320",
  null
  
)

export default component.exports